<template>
  <div style="width:100%;display:flex;flex-direction:row;">

<!--    <el-switch v-model="horizontal" class="mb-2" active-text="竖向" inactive-text="横向"/>-->
    <div ref="treeContainer" style="width: 75%">
      <vue3-tree-org
          :data="treeData"
          :horizontal="horizontal"
          :collapsable="collapsable"
          :label-style="style"
          :node-draggable="false"
          :scalable="true"
          :only-one-node="onlyOneNode"
          :default-expand-level="1"
          @on-node-click="onNodeClick"
      >
        <template v-slot="{node}">
          <div class="tree-org-node__text node-label" style="cursor:pointer;">
            <div class="custom-content" style="font-size: 18px;">{{node.label}}</div>
            <div style="text-align: center;font-size: 14px">{{node.$$data.employee_cnt}} <span v-if="node.$$data.employee_cnt >= 0">人</span></div>
            <div class="custom-tree-node">
              <el-avatar class="custom-avatar" shape="square" :src="(node.$$data.head_photo == null || node.$$data.head_photo.length===0) ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' : node.$$data.head_photo"></el-avatar>
              <div style="float: left;margin-left: 5px">
                <div style="font-size: 15px;font-weight: bold">{{node.$$data.head_name}}</div>
                <div style="font-size: 14px">{{node.$$data.head_position}}</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 自定义展开按钮 -->
        <template v-slot:expand="{node}">
          <div>{{node.children.length}}</div>
        </template>
      </vue3-tree-org>
    </div>
    <el-button class="export-button" size="medium" @click="exportTree" type="primary">导出图片</el-button>
    <div style="width: 25%;border-left: 1px solid lightgray">
      <div style="height: 110px" class="tree-org-node__text">
<!--        右侧部门名称-->
        <div class="custom-content" style="font-size: 18px;margin: 0 auto;width: fit-content">{{ currentDept.label }}</div>
        <div style="text-align: center;font-size: 14px">{{ formattedEmployeeCount }}</div>
        <div class="custom-tree-node" style="justify-content: center">
          <el-avatar class="custom-avatar" @click="headAvatarClick(currentDept)" shape="square" style="cursor:pointer;" :src="(currentDept.head_photo == null || currentDept.head_photo.length===0) ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' :currentDept.head_photo"></el-avatar>
          <div style="float: left;margin-left: 6px;white-space: nowrap;">
            <div style="font-size: 15px;font-weight: bold;">{{currentDept.head_name}}</div>
            <div style="font-size: 14px">{{currentDept.head_position}}</div>
          </div>
        </div>
        <div>
          <div style="font-size: 15px;font-weight: bold;margin:20px 0 0 10px">部门成员：
            <el-switch
              v-model="containChildDept"
              class="mb-2"
              active-text="含子部门"
              @change="containChildDeptChange"
          /></div>
        </div>
      </div>
      <div style="height: 80%; margin-top: 35px">
        <el-scrollbar>
          <div style="margin:10px;display: flex;justify-content: flex-start;flex-wrap: wrap">
            <div class="dept-tree-node" v-for="deptEmployee in currentDept.showDeptEmployee" :key="deptEmployee.id">
              <el-avatar shape="square" class="custom-avatar" style="cursor:pointer;" :src="(deptEmployee.photo == null || deptEmployee.photo.length===0) ? 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png' :deptEmployee.photo" @error="errorHandler" @click="avatarClick(deptEmployee)">

              </el-avatar>
              <div style="float: left;margin-left: 5px">
                <div style="font-size: 14px;font-weight: bold">{{deptEmployee.employee_name}}</div>
                <div style="font-size: 13px">{{deptEmployee.position_id}}</div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>

</template>

<script>
import {Vue3TreeOrg} from "vue3-tree-org";
import domtoimage from 'dom-to-image';
export default {
  name: "OrganizationStructure",
  components: {Vue3TreeOrg},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  setup(){
    return {
      errorHandler: () => {
        return true;
      }
    }
  },
  computed: {
    formattedEmployeeCount() {
      return this.currentDept.employee_cnt > 0 ? this.currentDept.employee_cnt + '人' : this.currentDept.employee_cnt;
    }
  },
  data() {
    return {
      treeData: {},
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      containChildDept: false,
      horizontal: false,
      collapsable: true,
      onlyOneNode: true,
      cloneNodeDrag: true,
      expandAll: true,
      style: {
        background: "#fff",
        color: "#5e6d82",
      },
      currentDept: {},
    };
  },
  methods: {
    async onNodeClick(e,data){
      console.log("onNodeClick");
      let params = {currDept: data}
      this.currentDept = await this.$http('orgStructureService.getDeptPhoto',params);
      if(this.currentDept){
        this.containChildDeptChange(this.containChildDept);
      }
    },
    //获取部门树
    async getDeptTreeData(){
      this.treeData = await this.$http('orgStructureService.getOrgStructureList')
      this.currentDept = this.treeData;
      this.containChildDept = false;
      if(this.currentDept){
        let params = {currDept: this.currentDept}
        this.currentDept = await this.$http('orgStructureService.getDeptPhoto',params);
        this.currentDept.showDeptEmployee = this.currentDept.currDeptEmployee;
      }
    },
    avatarClick(item){
      let windowObj = {}
      windowObj.component = "employee/EmployeeShow";
      windowObj.name = "员工档案 - "+item.employee_name;
      windowObj.parentData = {employee_id: item.id};
      windowObj.height = 800 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1350 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
    headAvatarClick(item){
      let windowObj = {}
      windowObj.component = "employee/EmployeeShow";
      windowObj.name = "员工档案 - "+item.head_name;
      windowObj.parentData = {employee_id: item.head_id};
      windowObj.height = 800 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1350 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
    containChildDeptChange(status){
      if(this.currentDept){
        if(status){
          this.currentDept.showDeptEmployee = this.currentDept.deptEmployee;
        }else {
          this.currentDept.showDeptEmployee = this.currentDept.currDeptEmployee;
        }
      }
    },
    exportTree() {
      const zmDraggable = this.$refs.treeContainer.querySelector('.zm-draggable');
      console.log("zmDraggable",zmDraggable.parentNode)
      if (zmDraggable && zmDraggable.parentNode) {
        // eslint-disable-next-line no-undef
        domtoimage.toPng(zmDraggable, {
          width: zmDraggable.scrollWidth,
          height: zmDraggable.scrollHeight,
          bgcolor: '#fff'
        }).then(dataUrl => {
          const img = new Image();
          img.src = dataUrl;
          console.log("src",img.src)
          const canvas = document.createElement('canvas');
          canvas.width = zmDraggable.scrollWidth;
          canvas.height = zmDraggable.scrollHeight;
          const ctx = canvas.getContext('2d');
          img.onload = () => {
            ctx.drawImage(img, 0, 0);
            const imgData = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = imgData;
            link.download =  '(鑫巨宏智能科技股份有限公司组织结构).png';
            link.click();
          };
        }).catch(error => {
          console.error('dom-to-image error:', error);
        });
      } else {
        console.error('zmDraggable is not attached to a Document');
      }
    },
  },
  created() {
    this.getDeptTreeData();
  }
};
</script>


<style scoped lang="less">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  padding-right: 8px;
  white-space: nowrap;
}

.custom-avatar {
  width: 35px; /* 设置宽度为二寸照片宽度 */
  height: 49px; /* 设置高度为二寸照片高度的1.5倍 */
  object-fit: cover; /* 确保图片覆盖整个容器，保持比例 */
  border-radius: 4px; /* 如果需要圆角效果 */
}

.node-label {
  margin-left: 8px;
}

.tree-org-node__text {
  text-align: left;
  font-size: 14px;


  .custom-content {
    text-align: center;
    color:#fff;
    background-color: #108ffe;
    padding: 0 2px 0 2px;
    white-space: nowrap;
  }
}
.export-button {
  position: absolute; /* 绝对定位 */
  top: 7px; /* 定位到容器的顶部 */
  right: 26%;
  z-index: 10; /* 确保按钮在内容之上 */
}
.dept-tree-node {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
  min-width:50%;
  margin-top: 20px;
}
</style>